import {useState} from 'react'
import styled from 'styled-components'
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { resetMemberSearchTerm, searchMembers, searchFellowMembers, setMemberSearchTerm } from 'features/memberships/membershipSlice';
import { useSelector, useDispatch } from 'react-redux'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'; 
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { toast } from 'react-toastify';

import { useTranslation } from 'react-i18next'

function MemberSearch({searchForFellowMembers}) {
  const { t: translate } = useTranslation()
  const dispatch = useDispatch()
  const [searchVal, setSearchVal] = useState('')
  const { searchTerm, isMemberSearchActive, isMbsSearchLoading } = useSelector((state) => state.memberships2)
  const [searchTermHover, setSearchTermHover] = useState()
  const [isFocused, setIsFocused] = useState(false)
  const { user } = useSelector((state) => state.auth)

  const handleSearch = (e) => {
    e.preventDefault()
    
    if(searchVal.length <= 2){
      return toast.error(translate('settings:membership.searchRequired'), {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: "light",
      })
    }

    dispatch(setMemberSearchTerm(searchVal))


    
    if(searchForFellowMembers){

      dispatch(searchFellowMembers({
          searchVal: searchVal 
      }))


    }else{
      dispatch(searchMembers({
        searchVal: searchVal
      }))
    }

  }

  const handleClearSearch = () => {
    setSearchVal('')
    dispatch(resetMemberSearchTerm())
  } 

//in redux create a copy of the current directoryItems array so that
// when the user is done searching ( the original search will create a new array of directoryItems to be displayed )
// the original array of directory items will be returned

  return (
    <MSWrap>
      <MemberSearchForm
        isFocused={isFocused}
        >
          <MSInput 
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            value={searchVal} 
            onChange={(e) => setSearchVal(e.target.value)} 
            placeholder={translate("web:settings.searchMembers")}
             /> 
          { isMbsSearchLoading ? (
            <SearchBtn> <HourglassEmptyIcon/> </SearchBtn> 
          )
          :
          (
            <SearchBtn 
                onClick={handleSearch} 
                // onSubmit={handleSearch}
                > 
                    <PersonSearchIcon/> 
            </SearchBtn> 
          )

          }

      </MemberSearchForm>
      {
            isMemberSearchActive && (
                  <SearchTermVal 
                    onMouseEnter={() => setSearchTermHover(true)} 
                    onMouseLeave={() => setSearchTermHover(false)}
                    onClick={handleClearSearch}
                    >

                            <ST>{searchTerm}</ST>
                        
                    <SearchOffIcon style={{
                      marginLeft: '0px',
                      marginTop: '0px',
                      display: 'flex', 
                      alignSelf: 'start',
                      justifySelf: 'start',
                      // fontSize: 'smaller', 
                      cursor: 'pointer', 
                      color: '#ff0000bf'}}/>
                  </SearchTermVal>      
            )
        }
    </MSWrap>

  )
}
const MSWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 0;
  flex: 1;
  @media (max-width: 768px) { 
    width: 100%; 
    flex-direction: column;
    margin-bottom: 5px;
    align-items: stretch;
  }
`

const MemberSearchForm = styled.form`
    margin-left: 0;
    padding: 0px;
    display: flex;
    flex-direction: row;
    align-self: flex-start; 
    justify-self: flex-start;
    width: min(360px, 100%);
    border-radius: 8px;
    border: 1px solid ${props => props.isFocused ? 'var(--themeColor)' : '#d8e0e8'};
    background-color: white;
    box-shadow: ${props => props.isFocused ? '0 0 0 3px rgba(0, 180, 204, 0.1)' : 'none'};
    padding: 2px;
    transition: all 0.3s ease-in-out;
    box-sizing: border-box;

    @media (max-width: 768px) {
      margin-left: 0px;
      width: 100%;
      justify-content: space-between;
      margin-bottom: 5px;
    }
`
const MSInput = styled.input`
    padding: 10px;
    outline: none;
    border: none;
    color: var(--lightThemeFontColor);
    border-radius: 7px 0px 0px 7px;
    min-width: 0;
    flex: 1;
`
const SearchBtn = styled.button`
  cursor: pointer;
  color: #ffffff;
  padding-left: 5px;
  padding-right: 5px;
  min-width: 40px;
  outline: none;
  border: none;
  background-color: var(--themeColor);
  border-radius: 6px;
  &:hover{
     background-color: var(--themeColorDark);
     color: white;
  }
`
const ST = styled.span`
  padding: 5px 8px;
  background-color: #00800091;
  color: white;
  min-width: 50px;
  width: fit-content;
  height: fit-content;
  cursor: pointer;
  border-radius: 4px;
  box-shadow: 0 0 10px #ccc;

`
const SearchTermVal = styled.div`
  margin-left: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: fit-content;
  align-self: center;
  justify-self: center;
  /* @media (max-width: 768px) {
    margin-left: 0px;
    align-self: flex-end;
    justify-self: flex-end;
  } */
  @media (max-width: 768px) {
    margin-left: 0;
    margin-top: 6px;
    align-self: flex-start;
  }
`

export default MemberSearch
